import { z } from 'zod';
import { api } from './api-client';
import { isNative, setToken, cacheProfile, clearNativeAuth } from './native-auth';

export const meAreaSchema = z.object({
  id: z.coerce.number(),
  codigo: z.string(),
  nome: z.string(),
  cor: z.string().nullish(),
  ordem: z.coerce.number().nullish(),
});
export type MeArea = z.infer<typeof meAreaSchema>;

export const userSchema = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string(),
  role: z.enum(['admin', 'gestor', 'colaborador']).or(z.string()),
  cargo: z.string().nullish(),
  avatar_color: z.string().nullish(),
  preferences: z.record(z.unknown()).nullish(),
  created_at: z.string().nullish(),
  last_login: z.string().nullish(),
  areas: z.array(meAreaSchema).default([]),
});
export type User = z.infer<typeof userSchema>;

export const meResponseSchema = z.object({
  user: userSchema,
});

export async function fetchCurrentUser(signal?: AbortSignal): Promise<User> {
  const res = await api('/api/auth/me', { schema: meResponseSchema, ...(signal && { signal }) });
  // Nativo: guarda o perfil pra renderizar o shell offline no próximo boot.
  if (isNative()) void cacheProfile(res.user);
  return res.user;
}

const loginResponseSchema = z.object({
  ok: z.boolean().optional(),
  token: z.string().nullish(),
  expiresIn: z.number().nullish(),
});

export async function login(input: { email: string; password: string; tenant_slug?: string }) {
  const res = await api('/login', {
    method: 'POST',
    body: input,
    schema: loginResponseSchema,
  });
  // Nativo: persiste o JWT pra usar como Bearer nas próximas chamadas.
  if (isNative() && res.token) await setToken(res.token);
  return res;
}

export async function logout() {
  if (isNative()) {
    await clearNativeAuth();
    return;
  }
  // Endpoint legado faz GET com redirect. Em SPA fazemos fetch e ignoramos redirect.
  await fetch('/auth/logout', { credentials: 'include', redirect: 'manual' });
}
